"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectURI = void 0;
var selectURI = exports.selectURI = function selectURI(operation, fallbackURI) {
  var context = operation.getContext();
  var contextURI = context.uri;
  if (contextURI) {
    return contextURI;
  } else if (typeof fallbackURI === "function") {
    return fallbackURI(operation);
  } else {
    return fallbackURI || "/graphql";
  }
};